// The active chart owns VT visibility, even when another timeframe has cached data.
export function timeframeTrendEnabled(data) {
    const overlays = ['onchart', 'offchart'].flatMap(side => data?.[side] || []);
    return overlays.some(overlay => overlay?.type === 'TimeframeTrend' &&
        (overlay.settings?.group || overlay.group) === 'VT' &&
        overlay.settings?.display !== false);
}
